export class FormEditorDialog {
  Titel: string;
  Form: string;
  Fragen: Array<Object>;
}
